import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { TranslationMode } from 'cng-common/features/translations/configs'
import { useSafetyTranslation } from 'cng-common/features/translations/hooks'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'
import { getTranslatedText } from 'partner360/helpers/getTranslatedText'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

export const GlobalPartnerFinancialColumnTitle = ({
  translationKey,
  valueType,
  fYear,
}: {
  translationKey: string
  valueType?: ActualsValueTypes
  fYear?: number
}) => {
  const t = useSafetyTranslation()
  const translationMode = useSelector(selectTranslationMode)

  const measure = valueType === ActualsValueTypes.Ndp ? 'NDP' : (valueType ?? '')
  const replaceParams = [
    { key: '{valueType}', value: measure },
    ...(fYear === undefined ? [] : [{ key: '{fYear}', value: String(fYear).slice(-2) }]),
  ]

  if (translationMode === TranslationMode.Edit) {
    return <Translation text={translationKey} span actionsInside replaceParams={replaceParams} />
  }

  return <>{getTranslatedText({ t, key: translationKey, replaceParams })}</>
}
